<template>
  <div class="row form-group">
    <div class="col-12">
      <p><b>UWAGA!</b></p>

      <div v-html="schema.data.incomeStatementText.$title" />
    </div>
  </div>
</template>

<script>
// @vuese
// Income statement component
// @Group formComponents
export default {
  props: {
    // Schema wniosku
    schema: { type: Object, required: true }
  }
};
</script>
